import React, { useState } from "react";
import { Col, Dropdown, Row, Table, Tag, Typography } from "antd";
import type { MenuProps, TableProps } from "antd";
import { MenuOutlined } from "@ant-design/icons";

import "./../../styles/tables.css";
import { formatDateForJustMonthDayAndYear } from "../../helpers/date";
import { getUserType } from "../../helpers/userDetails";
import TailSpinLoader from "../Items/Loaders/TailSpinLoader";
const ViewPackagesTableForDealer: React.FC<DealerPackagesTableProp> = ({
  packages,
  isLoading,
  handleUpdatePriceModal,
}) => {
  const role = getUserType();
  const [activeRow, setActiveRow] = useState<DealerPackage | null>(null);

  const packageOptions: MenuProps["items"] = [
    {
      key: "UPDATE_PRICE",
      label: (
        <Typography className="general-label-class">Update Price</Typography>
      ),
    },
  ];

  const handleMenuClick = (e: any) => {
    if (!activeRow) {
      return;
    }
    switch (e.key) {
      case "UPDATE_PRICE":
        handleUpdatePriceModal(activeRow);
        break;
    }
  };

  const columns: TableProps<DealerPackage>["columns"] = [
    {
      title: "Name",
      dataIndex: "packageName",
      key: "packageName",
    },
    {
      title: "Cost Price",
      dataIndex: "salePriceForDealer",
      key: "salePriceForDealer",
    },
    {
      title: "Sale Price",
      render: (row) => (
        <span>
          {row.endUserPriceDetails !== null
            ? row.endUserPriceDetails.salePrice
            : "Not Created"}
        </span>
      ),
    },
    {
      title: "Duration",
      dataIndex: "packageDuration",
      key: "packageDuration",
    },
    {
      title: "Pool",
      render: (row) => <span>{row.poolName ? row.poolName : "-"}</span>,
    },
    {
      title: "Profile",
      render: (row) => <span>{row.profileName}</span>,
    },
    {
      title: "Speed",
      render: (row) => (
        <span>
          {row.speedUp && row.speedDown && row.speedAbbreviation
            ? `${row.speedUp}/${row.speedDown} ${row.speedAbbreviation}`
            : "-"}
        </span>
      ),
    },
    {
      title: "Variable Recharge?",
      render: (row) => (
        <span>
          {Number(row.isVariableRechargeAllowed) === 1 ? `YES` : "NO"}
        </span>
      ),
    },
    {
      title: "Created",
      dataIndex: "dealerAssignedDate",
      render: (text) => (
        <span>{formatDateForJustMonthDayAndYear(new Date(text))}</span>
      ),
    },
  ];
  if (role === "DEALER") {
    columns.push({
      title: "Action",
      render: (row) => (
        <Dropdown
          menu={{
            items: packageOptions,
            onClick: handleMenuClick,
          }}
          placement="bottomRight"
        >
          <MenuOutlined
            onMouseEnter={(e) => {
              setActiveRow(row);
            }}
            className="cursor-pointer"
          />
        </Dropdown>
      ),
    });
  }
  return (
    <div className="general-table-container">
      {isLoading === true ? (
        <TailSpinLoader />
      ) : (
        <Row>
          <Col span={24}>
            <Typography className="general-table-heading">Packages</Typography>
            <Table
              className="striped-table"
              columns={columns}
              dataSource={packages}
              onRow={(record, rowIndex) => {
                return {};
              }}
              pagination={false}
            />
          </Col>
          <Col
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
              marginBottom: "20px",
            }}
            span={24}
          ></Col>
        </Row>
      )}
    </div>
  );
};
export default ViewPackagesTableForDealer;
